export default "__VITE_ASSET__CdQ3IfIw__"